import type { TSignInCallback } from '@cascade/core/auth';

export const parseSignInCallback = (
  params: URLSearchParams,
): TSignInCallback | undefined => {
  const code = params.get('code');

  if (code) {
    return { code };
  }

  const magicAuthCode = params.get('magic_auth_code');

  if (magicAuthCode) {
    return { magicAuthCode };
  }

  return undefined;
};
